import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import firstPart from "./locales/FirstPart.json";
import secondPart from "./locales/SecondPart.json";
import thirdPart from "./locales/ThirdPart.json";
import fourthPart from "./locales/FourthPart.json";
import fifthPart from "./locales/FifthPart.json";
import sixthPart from "./locales/SixthPart.json";
import header from "./locales/Header.json";
import bottomBar from "./locales/BottomBar.json";
import contactUs from "./locales/ContactUs.json";
import profile from "./locales/Profile.json";
import myLoan from "./locales/MyLoan.json";
import loan from "./locales/Loan.json";
import formIncome from "./locales/FormIncome.json";
import selectLoan from "./locales/SelectLoan.json";
import loanProcess from "./locales/LoanProcess.json";
import loanProcessForm from "./locales/LoanProcessForm.json";
import register from "./locales/Register.json";
import form1 from "./locales/Form1.json";
import form2 from "./locales/Form2.json";
import form3 from "./locales/Form3.json";
import loanCard from "./locales/LoanCard.json";
import myLoanItem from "./locales/MyLoanItem.json";
import editLoan from "./locales/EditLoan.json";
import formProfile from "./locales/FormProfile.json";
import downloadContract from "./locales/DownloadContract.json";
import myLoanReceipt from "./locales/MyLoanReceipt.json";
import payment from "./locales/Payment.json";
import requirement from "./locales/Requirement.json";
import installment from "./locales/Installment.json";
import job from "./locales/Job.json";
import fillForm from "./locales/FillForm.json";
import form from "./locales/Form.json";
import notification from "./locales/Notification.json";
import agreement from "./locales/Agreement.json";
import loanDetail from "./locales/LoanDetail.json";
import home from "./locales/Home.json";
import loanStatus from "./locales/LoanStatus.json";
import myLoanInvoice from "./locales/MyLoanInvoice.json";
// ✅ Get saved language from localStorage or default to 'th'
const savedLang = localStorage.getItem("i18nextLng") || "th";

i18n.use(initReactI18next).init({
  resources: {
    en: {
      firstPart: firstPart.en,
      secondPart: secondPart.en,
      thirdPart: thirdPart.en,
      fourthPart: fourthPart.en,
      fifthPart: fifthPart.en,
      sixthPart: sixthPart.en,
      header: header.en,
      bottomBar: bottomBar.en,
      contactUs: contactUs.en,
      profile: profile.en,
      myLoan: myLoan.en,
      loan: loan.en,
      formIncome: formIncome.en,
      selectLoan: selectLoan.en,
      loanProcess: loanProcess.en,
      loanProcessForm: loanProcessForm.en,
      register: register.en,
      form1: form1.en,
      form2: form2.en,
      form3: form3.en,
      job: job.en,
      loanCard: loanCard.en,
      myLoanItem: myLoanItem.en,
      editLoan: editLoan.en,
      formProfile: formProfile.en,
      downloadContract: downloadContract.en,
      myLoanReceipt: myLoanReceipt.en,
      myLoanInvoice: myLoanInvoice.en,
      payment: payment.en,
      requirement: requirement.en,
      installment: installment.en,
      fillForm: fillForm.en,
      form: form.en,
      notification: notification.en,
      agreement: agreement.en,
      loanDetail: loanDetail.en,
      home: home.en,
      loanStatus: loanStatus.en,
    },
    th: {
      firstPart: firstPart.th,
      secondPart: secondPart.th,
      thirdPart: thirdPart.th,
      fourthPart: fourthPart.th,
      fifthPart: fifthPart.th,
      sixthPart: sixthPart.th,
      header: header.th,
      bottomBar: bottomBar.th,
      contactUs: contactUs.th,
      profile: profile.th,
      myLoan: myLoan.th,
      loan: loan.th,
      formIncome: formIncome.th,
      selectLoan: selectLoan.th,
      loanProcess: loanProcess.th,
      loanProcessForm: loanProcessForm.th,
      register: register.th,
      form1: form1.th,
      form2: form2.th,
      form3: form3.th,
      job: job.th,
      loanCard: loanCard.th,
      myLoanItem: myLoanItem.th,
      editLoan: editLoan.th,
      formProfile: formProfile.th,
      downloadContract: downloadContract.th,
      myLoanReceipt: myLoanReceipt.th,
      myLoanInvoice: myLoanInvoice.th,
      payment: payment.th,
      requirement: requirement.th,
      installment: installment.th,
      fillForm: fillForm.th,
      form: form.th,
      notification: notification.th,
      agreement: agreement.th,
      loanDetail: loanDetail.th,
      home: home.th,
      loanStatus: loanStatus.th,
    },
  },

  lng: savedLang, // ✅ use saved language
  fallbackLng: "th",

  ns: [
    "firstPart",
    "secondPart",
    "thirdPart",
    "fourthPart",
    "fifthPart",
    "sixthPart",
    "header",
    "bottomBar",
    "contactUs",
    "profile",
    "myLoan",
    "loan",
    "formIncome",
    "selectLoan",
    "loanProcess",
    "loanProcessForm",
    "register",
    "form1",
    "form2",
    "form3",
    "job",
    "loanCard",
    "myLoanItem",
    "editLoan",
    "formProfile",
    "downloadContract",
    "myLoanReceipt",
    "myLoanInvoice",
    "payment",
    "requirement",
    "installment",
    "fillForm",
    "form",
    "notification",
    "agreement",
    "loanDetail",
    "loanStatus",
    "home",
  ],

  defaultNS: "firstPart",

  interpolation: { escapeValue: false },
});

export default i18n;
